let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2LnYX")).then(() => parcelRequire('jB18W'));